import { useTranslation } from 'react-i18next'

import {
  useCurrentMove,
  useUpdateCustomerAction,
} from '../../../modules/moves'
import { formatPhoneNumber } from '../../../common/phoneNumber'
import { type EditableSectionProps } from '../../EditableSections/editableSections.type'
import {
  Label,
  Value,
  Row,
  Cell,
} from '../../data'
import IdentificationForm from '../../forms/editmove/IdentificationForm'
import { errorNotification, successNotification } from '../../ToastNotifications'
import { useErrorFormatter } from '../../errors/useErrorFormatter'
import { type MoveCustomer } from '../../../modules/moves/core/models/subModels/moveCustomer.model'

const IdentificationSection: React.FC<EditableSectionProps> = ({
  isEditing,
  onClose,
  wide,
}) => {
  const { t } = useTranslation()
  const move = useCurrentMove()
  const [updateCustomer] = useUpdateCustomerAction()
  const formatError = useErrorFormatter()

  const onSubmit = async (data: MoveCustomer) => {
    try {
      await updateCustomer(data)
      successNotification(t('components.move.identification.success'))
      onClose()
    } catch (error) {
      errorNotification(formatError(error))
    }
  }

  if (isEditing) {
    return (
      <IdentificationForm
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    )
  }

  return (
    <>
      <Row>
        <Cell>
          <Label>
            { t('components.move.identification.firstName') }
          </Label>
          <Value>
            { move.customer.firstName }
          </Value>
        </Cell>

        <Cell>
          <Label>
            { t('components.move.identification.lastName') }
          </Label>
          <Value>
            { move.customer.lastName }
          </Value>
        </Cell>
      </Row>

      <Row>
        <Cell>
          <Label>
            { t('components.move.identification.email') }
          </Label>
          <Value>
            { move.customer.email }
          </Value>
        </Cell>

        <Cell>
          <Label>
            { t('components.move.identification.phoneNumber') }
          </Label>
          <Value>
            { formatPhoneNumber(move.customer.phoneNumber) }
          </Value>
        </Cell>
      </Row>
    </>
  )
}

export default IdentificationSection
